import { createSelector } from "reselect"
import { chain, get } from "lodash"
import { getSettings } from "./constraints"

const EMPTY_ARRAY = []

export const getForecasts = (state) => get(state, "global.data.forecasts.data.forecasts", EMPTY_ARRAY)

export const getSelectedForecast = createSelector(
  [getSettings, getForecasts],
  (settings, forecasts) => {
    const forecastValue = get(settings, "forecast.value")

    if (forecastValue) {
      return chain(forecasts)
        .find(forecast => forecast.id === settings.forecast.value)
        .value()
    }
    return null
  })
